module.exports = __webpack_public_path__ + "static/media/icon_checkin_admin.bf98c993.svg";